import moment from 'moment-timezone'
import { PROVISIONED_UI_FLAGS } from '@Builder/QuoteDetailPage/logic'
import { SettingOutlined } from '@ant-design/icons'

import Box from '~/core/Box'
import Text from '~/core/Text'
import { IdentityType } from '~/redux-modules/identity/type'
import { EditLink } from '../components'
import pageStyles from '../styles.css'
import {
    BORDER,
    TEXT_H3_STYLE,
    TEXT_LABEL_STYLE,
    ICON_STYLE,
} from '../styleConstants'
import { useFlagEnabled } from '~/lib/isFlagEnabled'

import { PasswordForm, MfaSection } from './components'
import { PASSWORD } from './constants'
import EmailAddressSection from './components/EmailAddressSection'
import { FinancePermissionsSection } from './components/FinancePermissionSection'

type AccountSettingPropsType = {
    identity: IdentityType
    selectedField: string | null
    handleSelectEdit: (selectedField: string | null) => void
    popConfirmation?: string | null
    setCurrentForm: Function
    queryString?: string
    businessAccountName?: string
}

export default function AccountSettings(props: AccountSettingPropsType) {
    const {
        identity,
        selectedField,
        handleSelectEdit,
        popConfirmation,
        setCurrentForm,
        queryString,
        businessAccountName,
    } = props

    const shouldShow2FA = identity.isAdmin
    const isBARolesEnabled = useFlagEnabled(
        PROVISIONED_UI_FLAGS.RELEASE_BA_ROLES_FE,
    )

    return (
        <Box className={pageStyles.section}>
            <Box className={pageStyles.header}>
                <SettingOutlined style={ICON_STYLE} />
                <Text style={TEXT_H3_STYLE}>Account settings</Text>
            </Box>
            <EmailAddressSection identity={identity} />
            <Box
                padding="24px 0"
                marginBottom={!shouldShow2FA && !businessAccountName && '16px'}
                borderBottom={(shouldShow2FA || businessAccountName) && BORDER}
                className={
                    selectedField === PASSWORD && pageStyles.mobileColBox
                }
            >
                <Text style={TEXT_LABEL_STYLE}>PASSWORD</Text>
                {selectedField === PASSWORD ? (
                    <PasswordForm
                        identity={identity}
                        warning={popConfirmation === PASSWORD}
                        setCurrentForm={setCurrentForm}
                        onCancel={() => handleSelectEdit(null)}
                    />
                ) : (
                    <EditLink
                        field={PASSWORD}
                        handleSelectEdit={handleSelectEdit}
                    />
                )}
            </Box>
            {businessAccountName && (
                <Box
                    padding="24px 0"
                    marginBottom={!shouldShow2FA && '16px'}
                    borderBottom={shouldShow2FA && BORDER}
                    className={pageStyles.mobileColBox}
                >
                    <Box className={pageStyles.mobileLabel}>
                        <Text style={TEXT_LABEL_STYLE}>ACCOUNT NAME</Text>
                    </Box>
                    <Box position="relative" flex="1" direction="col">
                        <Text fontWeight={500}>{businessAccountName}</Text>
                        <Text color="blackAlpha45">
                            Joined on {moment(new Date()).format('LL')}
                        </Text>
                    </Box>
                </Box>
            )}
            {isBARolesEnabled && (
                <FinancePermissionsSection
                    identity={identity}
                    shouldShow2FA={Boolean(shouldShow2FA)}
                    businessAccountName={businessAccountName}
                />
            )}
            {shouldShow2FA && (
                <MfaSection identity={identity} queryString={queryString} />
            )}
        </Box>
    )
}
